(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/slices/containers/selectors.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/slices/containers/selectors.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _RTK = RTK,
  createSelector = _RTK.createSelector;
const _svs$numbergames = svs.numbergames,
  productMapping = _svs$numbergames.productMapping,
  drawsApi = _svs$numbergames.draws.drawsApi;
const containerStates = svs.numbergames.fractiongames.constants.containerStates;
const productsSortOrder = svs.numbergames.fractiongames.data.productsSortOrder;
const getSortOrderByRegCloseTime = () => Object.entries(drawsApi.regCloseTime()).map(_ref => {
  let _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  return {
    productNumeric: productMapping.getProductNumeric(key),
    regCloseTime: new Date(value)
  };
}).sort((a, b) => a.regCloseTime - b.regCloseTime).map(item => item.productNumeric);
const selectContainers = createSelector(state => state.containers, containers => Object.values(containers), {
  memoizeOptions: {
    resultEqualityCheck: (arr1, arr2) => (arr1 === null || arr1 === void 0 ? void 0 : arr1.length) === (arr2 === null || arr2 === void 0 ? void 0 : arr2.length)
  }
});
const createSortedContainersSelector = productFilter => createSelector(selectContainers, containers => {
  containers = containers.filter(container => container.game);
  if (productFilter) {
    containers = containers.filter(container => productMapping.isSameProduct(container.productNumeric, productFilter));
  }
  const sortOrder = productsSortOrder !== null && productsSortOrder !== void 0 && productsSortOrder.length ? productsSortOrder : getSortOrderByRegCloseTime();
  return containers.sort((a, b) => parseInt(a.sharePrice, 10) - parseInt(b.sharePrice, 10)).sort((a, b) => sortOrder.indexOf(a.productNumeric) - sortOrder.indexOf(b.productNumeric)).map(container => container.containerId);
}, {
  memoizeOptions: {
    resultEqualityCheck: (arr1, arr2) => {
      var _arr1$join, _arr2$join;
      return (arr1 === null || arr1 === void 0 || (_arr1$join = arr1.join) === null || _arr1$join === void 0 ? void 0 : _arr1$join.call(arr1)) === (arr2 === null || arr2 === void 0 || (_arr2$join = arr2.join) === null || _arr2$join === void 0 ? void 0 : _arr2$join.call(arr2));
    }
  }
});
const createContainerSelector = containerId => createSelector(state => state.containers, containers => containers[containerId]);
const containerSelectors = {
  selectContainerId: container => container.containerId,
  selectActivatedDrawId: container => container.activatedDrawId,
  selectProductNumeric: container => container.productNumeric,
  selectDrawNumber: container => drawsApi.drawNumber(container.productNumeric),
  selectSharePrice: container => container.sharePrice,
  selectTotalPrice: container => container.totalPrice,
  selectSharesLeft: container => container.activatedDrawId ? container.totalShares - container.soldShares : 0,
  selectTotalShares: container => container.totalShares,
  selectBuyinCloseTime: container => container.buyinCloseTime,
  selectGame: container => container.game,
  selectIsOpen: container => container.containerState === containerStates.CONTAINER_OPEN,
  selectIsSoldOut: container => container.containerState === containerStates.GAME_SOLD_OUT,
  selectIsClosed: container => container.containerState === containerStates.CONTAINER_CLOSED,
  selectContainerState: container => container.containerState
};
const createContainerSelectors = containerId => {
  const selectContainer = createContainerSelector(containerId);
  return Object.entries(containerSelectors).reduce((acc, _ref3) => {
    let _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      selector = _ref4[1];
    return Object.assign(acc, {
      [key]: createSelector(selectContainer, selector)
    });
  }, {});
};
Object.assign(svs.numbergames.fractiongames.redux.slices.containers, {
  selectors: {
    createSortedContainersSelector,
    createContainerSelectors
  }
});

 })(window);